<template>
	<div class="notfound">正在建设中...</div>
</template>

<script>
export default {
	methods: {}
};
</script>

<style lang="less" scoped>
.notfound {
	height: 100%;
	width: 100%;
	text-align: center;
	padding-top: 20%;
	vertical-align: middle;
	font-size: 50px;
	font-weight: 700;
	color: @color;
}
</style>
